import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Box,
  IconButton,
} from "@mui/material";
import ButtonToIndex from "./ButtonToIndex";

export default function UnreadModalPC({
  open,
  onClose,
  activeType,
  projectIndexUrl,
  jobIndexUrl,
  unreadProjects,
  unreadJobs,
}) {
  const title = activeType === "projects" ? "未読プロジェクト" : "未読求人";
  const items = activeType === "projects" ? unreadProjects : unreadJobs;
  return (
    <Dialog
      open={open}
      onClose={onClose}
      scroll="paper"
      sx={{
        zIndex: (theme) => theme.zIndex.modal + 1,
      }}
      PaperProps={{
        sx: {
          py: "28px",
          px: "68px",
          maxWidth: "764px",
          width: "100%",
          borderRadius: 0,
          maxHeight: "80vh",
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      {/* ヘッダー */}
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <DialogTitle
          sx={{
            fontSize: "20px",
            fontWeight: "bold",
            mb: "28px",
            p: 0,
            position: "relative",
          }}
        >
          {title}
        </DialogTitle>
        <IconButton
          sx={{
            width: 60,
            height: 60,
            p: 0,
            fontSize: "30px",
            position: "absolute",
            top: 0,
            right: 0,
            borderRadius: 0,
          }}
          onClick={onClose}
        >
          ×
        </IconButton>
      </Box>

      {/* 本体：上スクロール / 下固定 */}
      <DialogContent
        sx={{
          p: 0,
          display: "flex",
          flexDirection: "column",
          flex: 1,
          minHeight: 0,
        }}
      >
        {/* スクロール領域 */}
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            overflowY: "auto",
            overflowX: "hidden",
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            mb: "28px",
          }}
        >
          {items.length === 0 ? (
            <Typography>
              {activeType === "projects"
                ? "未読のプロジェクトはありません"
                : "未読の求人はありません"}
            </Typography>
          ) : (
            items.map((item) => {
              const href =
                activeType === "projects" ? `/projects/${item.id}` : `/jobs/${item.id}`;

              return (
                <Box
                  key={item.id}
                  component="a"
                  href={href}
                  onClick={onClose}
                  sx={{
                    pt: "29px",
                    pb: "8px",
                    px: "12px",
                    backgroundColor: "#F6F6F7",
                    cursor: "pointer",
                    "&:hover": { bgcolor: "#eee" },
                    display: "block",
                    textDecoration: "none",
                    color: "inherit",
                    borderRadius: 1.5,
                  }}
                >
                  <Typography>{item.title}</Typography>
                  <Typography>{item.price}</Typography>
                  <Typography sx={{ fontSize: "12px", textAlign: "right", mt: "8px" }}>
                    {item.date}
                  </Typography>
                </Box>
              );
            })
          )}
        </Box>

        {/* 固定ボタン */}
        <Box sx={{ flexShrink: 0 }}>
          <ButtonToIndex
            activeType={activeType}
            projectIndexUrl={projectIndexUrl}
            jobIndexUrl={jobIndexUrl}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
}
